import React from "react";
import NewMenu from "./NewMenu";
import NavBar from "../navbar/NavBar";
import Footer from "../footer/Footer";

function MenuPage({ lang }) {
  return (
    <>
      <NavBar lang={lang} />
      <NewMenu lang={lang} />
      <Footer lang={lang} />
    </>
  );
}

export default MenuPage;
